// Action Types
export const DEACTIVATE_VAS_CONTROL_DATA_REQUEST = "DEACTIVATE_VAS_CONTROL_DATA_REQUEST";
export const DEACTIVATE_VAS_CONTROL_DATA_SUCCESS = "DEACTIVATE_VAS_CONTROL_DATA_SUCCESS";
export const DEACTIVATE_VAS_CONTROL_DATA_FAILURE = "DEACTIVATE_VAS_CONTROL_DATA_FAILURE";
export const DEACTIVATE_VAS_CONTROL_DATA_RESET = "DEACTIVATE_VAS_CONTROL_DATA_RESET";
// Action Creators
export const deactivateVASControlDataRequest = (payload) => ({
    type: DEACTIVATE_VAS_CONTROL_DATA_REQUEST,
    payload,
});
export const deactivateVASControlDataSuccess = (payload) => ({
    type: DEACTIVATE_VAS_CONTROL_DATA_SUCCESS,
    payload,
});
export const deactivateVASControlDataFailure = (payload) => ({
    type: DEACTIVATE_VAS_CONTROL_DATA_FAILURE,
    payload,
});
export const deactivateVASControlDataReset = () => ({
    type: DEACTIVATE_VAS_CONTROL_DATA_RESET,
});
